import { render, staticRenderFns } from "./safeSetting.vue?vue&type=template&id=50f3c93c&scoped=true"
import script from "./safeSetting.vue?vue&type=script&lang=js"
export * from "./safeSetting.vue?vue&type=script&lang=js"
import style0 from "./safeSetting.vue?vue&type=style&index=0&id=50f3c93c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f3c93c",
  null
  
)

export default component.exports